import { render, staticRenderFns } from "./LinkBox.vue?vue&type=template&id=1e92a65e&scoped=true&"
import script from "./LinkBox.vue?vue&type=script&lang=js&"
export * from "./LinkBox.vue?vue&type=script&lang=js&"
import style0 from "./LinkBox.vue?vue&type=style&index=0&id=1e92a65e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e92a65e",
  null
  
)

export default component.exports